import { createActionsHook, createStateHook, createStore } from 'react-sweet-state';
import { ConversationProvider } from '../../common/types';
import { setProvider, resetState } from './actions';
import { RoutingStateContainer } from './container';
import type { State } from './types';

const initialState: State = {
    provider: ConversationProvider.VIRTUAL_AGENT,
    contextId: '',
    isRouting: false,
};

const store = createStore({
    initialState,
    actions: {
        setProvider,
        resetState,
    },
    name: 'VIRTUAL_AGENT_ROUTING',
    containedBy: RoutingStateContainer,
    handlers: {
        onInit:
            () =>
            ({ setState }, { contextId }) => {
                setState({ contextId });
            },
    },
});

export const useProvider = createStateHook(store, {
    selector: (state) => state.provider,
});

export const useIsRouting = createStateHook(store, {
    selector: (state) => state.isRouting,
});

export const useActions = createActionsHook(store);
